/**
 * Shared Funding UI style recipes — modal chrome, cards, primary/secondary CTAs.
 * Spread into makeStyles() to avoid copy-pasting Desktop-856 modal/card patterns.
 */
import { fundingColors as C } from './fundingColors'
import { fundingFont, fundingType } from './fundingTypography'

/** Standard single-line form control height (float fields, selects, uploads). */
export const FUNDING_FORM_FIELD_HEIGHT = 44

export const fundingFormFieldBox = {
  boxSizing: 'border-box' as const,
  minHeight: FUNDING_FORM_FIELD_HEIGHT,
  height: FUNDING_FORM_FIELD_HEIGHT,
}

export const fundingModalPaper = {
  boxSizing: 'border-box' as const,
  width: 800,
  maxWidth: '92vw',
  borderRadius: 8,
  padding: 40,
  display: 'flex' as const,
  flexDirection: 'column' as const,
  gap: 40,
  fontFamily: fundingFont,
  color: C.strongText,
  backgroundColor: C.cardBg,
}

export const fundingModalTitleIcon = {
  width: 28,
  height: 28,
  flexShrink: 0,
  display: 'flex' as const,
  alignItems: 'center' as const,
  justifyContent: 'center' as const,
  borderRadius: 4,
  backgroundColor: C.iconBoxBg,
  '& svg': { fontSize: 16, color: C.strongText },
}

export const fundingModalTitle = {
  fontFamily: fundingFont,
  fontSize: 22,
  fontWeight: 400,
  lineHeight: '28px',
  color: C.strongText,
  margin: 0,
}

export const fundingCardShell = {
  boxSizing: 'border-box' as const,
  padding: 24,
  borderRadius: 8,
  backgroundColor: C.cardBg,
}

export const fundingCardIconBox = {
  width: 24,
  height: 24,
  display: 'inline-flex' as const,
  alignItems: 'center' as const,
  justifyContent: 'center' as const,
  borderRadius: 4,
  backgroundColor: C.iconBoxBg,
  flexShrink: 0,
  '& svg': { fontSize: 14, color: C.strongText },
}

export const fundingPrimaryButton = {
  ...fundingType.button,
  display: 'inline-flex' as const,
  alignItems: 'center' as const,
  justifyContent: 'center' as const,
  gap: 8,
  border: 'none' as const,
  borderRadius: 4,
  padding: '8px 16px',
  cursor: 'pointer' as const,
  backgroundColor: C.ctaFill,
  // Figma / Funding CTAs: dark label on Labra orange (not white on orange).
  color: C.darkText,
  '&:disabled': {
    cursor: 'default' as const,
    opacity: 0.38,
  },
}

export const fundingSecondaryButton = {
  ...fundingType.button,
  display: 'inline-flex' as const,
  alignItems: 'center' as const,
  justifyContent: 'center' as const,
  gap: 8,
  borderRadius: 4,
  padding: '8px 16px',
  cursor: 'pointer' as const,
  backgroundColor: C.cardBg,
  border: `1px solid ${C.buttonBorder}`,
  color: C.strongText,
  '&:disabled': {
    cursor: 'default' as const,
    opacity: 0.38,
  },
}

export const fundingReviewChip = {
  display: 'inline-flex' as const,
  alignItems: 'center' as const,
  gap: 6,
  padding: '4px 8px',
  borderRadius: 8,
  border: `1px solid ${C.reviewBorder}`,
  backgroundColor: C.cardBg,
  fontFamily: fundingFont,
  fontSize: 11,
  fontWeight: 500,
  lineHeight: '16px',
  color: C.strongText,
  cursor: 'pointer' as const,
}
